module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAfElEQVQoU8WPsQ3CUBBDfSX7UPjPwAJpKIJAKbJMqoxD7b8AjGN0ET/6CgNwlXV+urMD3Ui6AriQHNo6mqi1ngHcbU8AZpJrehuQpu2H7SUiXgBuAE4JRW+WUt6STDIkjQmlmG0/08xrDfjqcc/QsvTAnuHQZHvx0+KPFz5qGVCH+cD8rAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sort-up.png
// module id = UQkt
// module chunks = 2